import { useContext } from 'react';

import { CesiumCollectionContext } from 'app/agriculture/contexts/CesiumCollectionContextProvider';

export function useCesium() {
    const { iconCollection, markerCollection } = useContext(CesiumCollectionContext);

    if (!iconCollection) throw new Error('no iconCollection in context');

    return {
        iconCollection, // For displaying permanent things on the map i.e. notes, gates, tasks, etc
        markerCollection, // For displaying temporary things on the map i.e. position marker. There should only be one
    };
}
